import React from "react";

const ReviewSummaryList = ({reviewSummary}: ReviewSummaryProps) => {
    console.log("reviewSummary is ", reviewSummary)
    
    if (!reviewSummary) {
        throw new Error('ReviewSummary is required but was not provided');
    }
    
    return (
        <>
            <h2 data-testid="reviewSummary" className="visible-only-to-screen-reader">Detailed Reviewer Activity</h2>
            <ul className="review-comments">
                <li>{`Reviews completed: ${reviewSummary.ReviewsCompleted}`}</li>
                <li>{`Review invitations accepted: ${reviewSummary.ReviewInvitationsAccepted}`}</li>
                <li>{`Review invitations sent: ${reviewSummary.ReviewInvitationsSent}`}</li>
            </ul>
        </>
    );
};

type ReviewSummaryProps = {
    reviewSummary?: ReviewSummary;
}

export default ReviewSummaryList;
